import AbstractModal from './AbstractModal';

export default class extends AbstractModal {
    constructor(m) {
        super(m);
    }

    init() {
        super.init([this.el]);
    }
}
